// ThinkingBlock: collapsed summary + expandable reasoning timeline
// (WEB-8005). Composed by praxisStyles.ts at the section's original
// position — source order is part of the cascade.
export const praxisThinkingBlock = `
/* ThinkingBlock — Claude-style: collapsed one-sentence summary, expandable timeline */
.pr-think {
  margin: 2px 0 8px;
}
.pr-think-summary {
  display: flex; align-items: center; gap: 6px;
  max-width: 100%; text-align: left;
  background: none; border: 0; padding: 0; cursor: pointer;
  color: var(--pr-ink-4); font-size: 13px; line-height: 1.5;
}
.pr-think-summary:hover { color: var(--pr-ink-3); }
.pr-think-summary-text {
  min-width: 0;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
/* Pages' live line of reasoning (WEB-14623) — takes all the truncation, so the label stays whole. */
.pr-think-preview {
  min-width: 0; flex-shrink: 999; opacity: 0.8;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.pr-think-summary-icon { flex-shrink: 0; color: var(--pr-ink-4); }
.pr-think-chev {
  flex-shrink: 0; opacity: 0.7;
  transition: transform 150ms ease;
}
.pr-think-chev-open { transform: rotate(90deg); }

/* Expanded reasoning — the full text, bounded and scrollable. */
.pr-think-full {
  font-size: 13px; color: var(--pr-ink-3); line-height: 1.55;
  white-space: pre-wrap; word-break: break-word; overflow-wrap: anywhere;
  margin-top: 6px; padding-left: 20px;
  max-height: 320px; overflow-y: auto;
}
.pr-think-detail { margin-top: 2px; }
.pr-think-done {
  display: flex; align-items: center; gap: 6px;
  margin-top: 10px; padding-left: 3px;
  font-size: 13px; color: var(--pr-ink-4); line-height: 1.5;
}
.pr-think-done svg { flex-shrink: 0; }
.pr-think-pulse { animation: pr-think-pulse 1.6s ease-in-out infinite; }
@keyframes pr-think-pulse {
  0%, 100% { opacity: 0.45; }
  50% { opacity: 1; }
}
`;
